exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".clipping{overflow:hidden;height:100%;width:100%}.embeddedChat{position:relative;top:-50px;height:calc(100% + 160px);width:100%}", "", {"version":3,"sources":["/build/src/code.justin.tv/web/wall/src/components/chat-player/style.css"],"names":[],"mappings":"AAAA,UACE,gBAAiB,AACjB,YAAa,AACb,UAAY,CACb,AAGD,cACE,kBAAmB,AACnB,UAAW,AACX,0BAA2B,AAC3B,UAAY,CACb","file":"style.css","sourcesContent":[".clipping {\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n\n\n.embeddedChat {\n  position: relative;\n  top: -50px;\n  height: calc(100% + 160px);\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./src/components/chat-player/style.css
// module id = 41
// module chunks = 0